import React from 'react';
import { motion } from 'framer-motion';
import { usePortal } from '../contexts/PortalContext';
import { ClientShell } from '../components/ClientShell';
import { Home } from './client/Home';
import { Project } from './client/Project';
import { Episodes } from './client/Episodes';
import { EpisodeReview } from './client/EpisodeReview';
import { Transcript } from './client/Transcript';
import { Files } from './client/Files';
import { Schedule } from './client/Schedule';
export function ClientApp() {
  const {
    clientRoute
  } = usePortal();
  return <ClientShell data-id="element-677" data-mp="k135md6smu2s">
      <motion.div key={clientRoute} initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-678" data-mp="k2npn8vheume">
        {clientRoute === 'home' && <Home data-id="element-679" data-mp="17pm646jlq2kb" />}
        {clientRoute === 'project' && <Project data-id="element-680" data-mp="17rgnxbzktek6" />}
        {clientRoute === 'episodes' && <Episodes data-id="element-681" data-mp="12zfdlvlyxxws" />}
        {clientRoute === 'episode' && <EpisodeReview data-id="element-682" data-mp="12xulsdr1gt2m" />}
        {clientRoute === 'transcript' && <Transcript data-id="element-683" data-mp="2q6jofoo1te9i" />}
        {clientRoute === 'files' && <Files data-id="element-684" data-mp="2q8wg4tjlz2zr" />}
        {clientRoute === 'schedule' && <Schedule data-id="element-685" data-mp="2u8n1uiua2sxf" />}
      </motion.div>
    </ClientShell>;
}